module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-11-b7c2d6812ab91e2f42dbdcc24c69bf37.svg";